import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID, DOCUMENT } from '@angular/core';
import * as i0 from "@angular/core";
export let AccessibilityCssVarsHelper = /*#__PURE__*/(() => {
  class AccessibilityCssVarsHelper {
    constructor() {
      this.isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
      this.doc = inject(DOCUMENT);
    }
    overrideCssVars(vars) {
      if (this.isBrowser) {
        Object.entries(vars).forEach(([varName, value]) => {
          this.doc.documentElement.style.setProperty(varName, value, 'important');
        });
      }
    }
    removeCssVarsOverride(vars) {
      if (this.isBrowser) {
        vars.forEach(varName => {
          this.doc.documentElement.style.removeProperty(varName);
        });
      }
    }
    static {
      this.ɵfac = function AccessibilityCssVarsHelper_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityCssVarsHelper)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessibilityCssVarsHelper,
        factory: AccessibilityCssVarsHelper.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessibilityCssVarsHelper;
})();